

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// getUserAllUnreadNotifications
// GETUSERALLUNREADNOTIFICATIONS   

const GETUSERALLUNREADNOTIFICATIONS= createAsyncThunk(
  "getUserAllUnreadNotifications/getUserAllUnreadNotifications",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getUserAllUnreadNotificationsSlice = createSlice({
  name: "getUserAllUnreadNotificationsSlice",
  initialState: {
    getUserAllUnreadNotifications: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetUserAllUnreadNotifications: (state) => {
        state.getUserAllUnreadNotifications.loading = false
        state.getUserAllUnreadNotifications.error = false
        state.getUserAllUnreadNotifications.data = []
        state.getUserAllUnreadNotifications.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETUSERALLUNREADNOTIFICATIONS.fulfilled, (state, action) => {
      state.getUserAllUnreadNotifications = {
        ...state.getUserAllUnreadNotifications,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUSERALLUNREADNOTIFICATIONS.pending, (state, action) => {
      state.getUserAllUnreadNotifications = {
        ...state.getUserAllUnreadNotifications,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUSERALLUNREADNOTIFICATIONS.rejected, (state, action) => {
      state.getUserAllUnreadNotifications = {
        ...state.getUserAllUnreadNotifications,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getUserAllUnreadNotificationsAction = {
    GETUSERALLUNREADNOTIFICATIONS,
};

export { getUserAllUnreadNotificationsAction };
export default getUserAllUnreadNotificationsSlice.reducer;
export const {setInitialStateOfgetUserAllUnreadNotifications} = getUserAllUnreadNotificationsSlice.actions